import { Component, Input, HostListener } from '@angular/core';
import { MatButtonModule } from '@angular/material/button'; // Import MatButtonModule

@Component({
  selector: 'app-generic-button',
  imports: [MatButtonModule],
  templateUrl: './generic-button.component.html',
  styleUrl: './generic-button.component.css',
})
export class GenericButtonComponent {
  @Input() textContent: string = 'Generic Button';
  @Input() clickEvent: () => void = () => {};
  @Input() disabled: boolean = false;
  @Input() color: string = 'accent';
  @Input() keyListener: string = '';

  @HostListener('window:keyup', ['$event'])
  KeyListen(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;

    //Ensure that we can make newlines, when in a textarea field
    if (
      this.keyListener == 'Enter' &&
      target &&
      target.tagName.toLowerCase() === 'textarea'
    ) {
      return;
    }

    //Ensure that we can delete text, when in textarea or textbox
    if (
      this.keyListener == 'Delete' &&
      target &&
      (target.tagName.toLowerCase() === 'textarea' ||
        target.tagName.toLowerCase() === 'input')
    ) {
      return;
    }

    if (!this.disabled && event.key === this.keyListener) {
      if (this.clickEvent != null) {
        this.clickEvent();
      }
    }
  }
}
